import { URI } from '@/config/config'

export default async ({ rootState }, { licencePlate }) => {
  const opts = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'user-token': rootState['DATA-ACCESS'].userToken
    }
  }

  try {
    const userLoginInfoResult = await fetch(`${URI}vehicle/history/${licencePlate}`, opts)
    const resultJson = await userLoginInfoResult.json()

    if (userLoginInfoResult.status !== 200) {
      return Promise.reject(resultJson)
    }

    return resultJson.result
  } catch (error) {
    return Promise.reject(error)
  }
}